/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpGameStateResponse
 */
export interface FuelUpGameStateResponse {
    /**
     * 
     * @type {string}
     * @memberof FuelUpGameStateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FuelUpGameStateResponse
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    currentPosition: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    totalMovesCompleted: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    availableMoves?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    spendRemainder?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    totalFuelSpent: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    totalFuelEarned: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    prestigeLevel: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    completedLoops: number;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpGameStateResponse
     */
    lastMoveAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpGameStateResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {object}
     * @memberof FuelUpGameStateResponse
     */
    vault?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof FuelUpGameStateResponse
     */
    unlockedAchievements?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    longestStreak?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    bestSingleMove?: number;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpGameStateResponse
     */
    lastLoginBonus?: Date;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelUpGameStateResponse
     */
    claimedSpaces?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameStateResponse
     */
    updatedAt?: number;
}

/**
 * Check if a given object implements the FuelUpGameStateResponse interface.
 */
export function instanceOfFuelUpGameStateResponse(value: object): value is FuelUpGameStateResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('currentPosition' in value) || value['currentPosition'] === undefined) return false;
    if (!('totalMovesCompleted' in value) || value['totalMovesCompleted'] === undefined) return false;
    if (!('totalFuelSpent' in value) || value['totalFuelSpent'] === undefined) return false;
    if (!('totalFuelEarned' in value) || value['totalFuelEarned'] === undefined) return false;
    if (!('prestigeLevel' in value) || value['prestigeLevel'] === undefined) return false;
    if (!('completedLoops' in value) || value['completedLoops'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function FuelUpGameStateResponseFromJSON(json: any): FuelUpGameStateResponse {
    return FuelUpGameStateResponseFromJSONTyped(json, false);
}

export function FuelUpGameStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpGameStateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'currentPosition': json['currentPosition'],
        'totalMovesCompleted': json['totalMovesCompleted'],
        'availableMoves': json['availableMoves'] == null ? undefined : json['availableMoves'],
        'spendRemainder': json['spendRemainder'] == null ? undefined : json['spendRemainder'],
        'totalFuelSpent': json['totalFuelSpent'],
        'totalFuelEarned': json['totalFuelEarned'],
        'prestigeLevel': json['prestigeLevel'],
        'completedLoops': json['completedLoops'],
        'lastMoveAt': json['lastMoveAt'] == null ? undefined : (new Date(json['lastMoveAt'])),
        'isActive': json['isActive'],
        'vault': json['vault'] == null ? undefined : json['vault'],
        'unlockedAchievements': json['unlockedAchievements'] == null ? undefined : json['unlockedAchievements'],
        'longestStreak': json['longestStreak'] == null ? undefined : json['longestStreak'],
        'bestSingleMove': json['bestSingleMove'] == null ? undefined : json['bestSingleMove'],
        'lastLoginBonus': json['lastLoginBonus'] == null ? undefined : (new Date(json['lastLoginBonus'])),
        'claimedSpaces': json['claimedSpaces'] == null ? undefined : json['claimedSpaces'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function FuelUpGameStateResponseToJSON(json: any): FuelUpGameStateResponse {
    return FuelUpGameStateResponseToJSONTyped(json, false);
}

export function FuelUpGameStateResponseToJSONTyped(value?: FuelUpGameStateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'currentPosition': value['currentPosition'],
        'totalMovesCompleted': value['totalMovesCompleted'],
        'availableMoves': value['availableMoves'],
        'spendRemainder': value['spendRemainder'],
        'totalFuelSpent': value['totalFuelSpent'],
        'totalFuelEarned': value['totalFuelEarned'],
        'prestigeLevel': value['prestigeLevel'],
        'completedLoops': value['completedLoops'],
        'lastMoveAt': value['lastMoveAt'] == null ? undefined : ((value['lastMoveAt']).toISOString()),
        'isActive': value['isActive'],
        'vault': value['vault'],
        'unlockedAchievements': value['unlockedAchievements'],
        'longestStreak': value['longestStreak'],
        'bestSingleMove': value['bestSingleMove'],
        'lastLoginBonus': value['lastLoginBonus'] == null ? undefined : ((value['lastLoginBonus']).toISOString()),
        'claimedSpaces': value['claimedSpaces'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

